import { useReactQuery } from "components/RemoteData";

import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { ILoggedUserDto } from "../../user/application/types/ILoggedUserDto";
import { ILoggedUser } from "../../user/application/types/ILoggedUser";
import { useGetAuthorizationStore } from "./useGetAuthorizationStore";

export const useSsoAccountActivation = (tokenId: string) => {
  const { setAuthorization } = useGetAuthorizationStore((state) => ({
    userId: state.userId,
    setAuthorization: state.setAuthorization,
  }));

  return useReactQuery<ILoggedUser>(
    registrationConfirmKey(tokenId),
    () =>
      ssoAccountActivation(tokenId).then((res) => {
        setAuthorization(res.id, tokenId);
        return res;
      }),
    {
      refetchOnWindowFocus: false,
    }
  );
};

const ssoAccountActivation = (token: string): Promise<ILoggedUser> => {
  return httpService()
    .post<ILoggedUserDto>(`/e-reservation/account-sso-activation/${token}`)
    .then((res) => {
      return {
        ...res,
        loginDate: DateObject(res.loginDate),
      };
    });
};

const registrationConfirmKey = (tokenId: string) => {
  return [`registration-confirmation-${tokenId}`];
};
